@if (hasCryptoAsset) {
  <div class="col-12 zero-text p-small-reg text-center mt-3">{{ 'savings-plan.savings-plan-form.donau-capital-hint' | transloco }}</div>
}
